import { Button } from "@mui/material"
import SText from "../../../../components/SText"
import Colors from "../../../../components/utils/Colors"
import styles from "./DownloadAppModal.module.scss"
import { GOOGLE_PLAY, APPLE_STORE } from "../../../../constants/urls"

const DownloadAppModal = ({ isOpen, setClose }) => {
    return isOpen && (
        <div className={ styles.wrap }>
            <div className={ styles.window }>
                <SText size={ 16 } weight={ 500 }>Спасибо! Мы приняли ваш заказ!</SText>
                <img src="/icons/cross_gray.svg" alt="cross" className={ styles.cross } onClick={ () => setClose(false) } />
                <hr className={ styles.separator } />
                <SText size={ 16 } weight={ 900 }>Хотите добавить товар к заказу, <br></br> отследить курьера или связаться <br></br>с диспетчером?</SText>
                <SText size={ 20 } weight={ 900 } color={ Colors.green }>Это удобно сделать <br></br>в нашем приложении!</SText>
                <div className={ styles.mobile }>
                    <img src={ "/images/mobile.png" } alt="mobile" />
                </div>
                <Button style={ { background: Colors.green, color: "#fff", padding: "19px 22px", borderRadius: "21px", fontFamily: "DINPro-Bold", textTransform: "none", fontSize: "16px" } }>Скачать приложение</Button>
                <div className={ styles.app_markets }>
                <a href={APPLE_STORE}>
                    <img src={ "/icons/apple_store.svg" } alt="apple store" />
                </a>
                <a href={GOOGLE_PLAY}>
                    <img src={ "/icons/google_play.svg" } alt="google play" />
                </a>
                </div>
                <div className={ styles.text_icon }>
                    <img src={ "/images/petard.png" } alt="petard" className={ styles.petard } />
                    <SText size={ 16 } weight={ 500 } className={ styles.text_center } style={ { textAlign: "left" } }>Мы также дарим вам 300 экобаллов <br></br> на ваш первый заказ, оформленный <br></br>через приложение</SText>
                </div>
            </div>
        </div>
    )
}

export default DownloadAppModal